export default __webpack_public_path__ + "static/media/faisal-3.daab6983.png";